import { Children, isValidElement } from "react"
import type { IProps } from "./interfaces"
import classes from "./styles.module.css"

/**
 * Staggered entrance for a list of children — each rises + fades in turn, so a
 * grid of cards visibly "builds" rather than appearing all at once. Pure CSS
 * (transform + opacity, GPU-friendly); honours `prefers-reduced-motion` by
 * showing everything instantly. Reusable: the finalize→summary reveal uses it,
 * but it's content-agnostic.
 *
 * Each child is wrapped in an animating cell that becomes the grid/flow item in
 * the parent's layout (so place `<StaggerReveal>` directly inside the grid/
 * stack you want to cascade).
 */
export function StaggerReveal({ active, stepMs = 80, baseMs = 0, children }: IProps): React.JSX.Element {
  return (
    <>
      {Children.map(children, (child, i) => {
        if (!isValidElement(child)) return child
        return (
          <div
            className={`${classes.cell} ${active ? classes.active : ""}`}
            style={{ "--reveal-delay": `${baseMs + i * stepMs}ms` } as React.CSSProperties}
          >
            {child}
          </div>
        )
      })}
    </>
  )
}
